import {Injectable} from '@angular/core';

import {AuthenticationService} from './index';
import {LoginHelper} from '../helpers';
import {BehaviorSubject, Subject, tap} from "rxjs";
import {Load} from "../_decorators/loading.decorator";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {IndexConfigService} from "./index.config.service";

@Injectable()
export class SapProfileService {
  constructor(public http: HttpClient,
              public authenticationService: AuthenticationService,
              public config: IndexConfigService) {
  }

  public profileChanged = new BehaviorSubject<any>(null);

  public url(method: string, id: number = undefined, submethod: string = undefined) {
    let url = this.config.api + '/api/' + method;
    if (id) url += '/' + id;
    if (submethod) url += '/' + submethod;
    return url;
  }

  getSapProfiles() {
    return this.http.get<any>(this.url('sapProfiles'));
  }
  getSapProfile(id) {
    return this.http.get<any>(this.url(`sapProfiles/${id}`));
  }

  deleteSapProfile(sapProfileId: number) {
    return this.http.delete<any>(this.url('sapProfile/' + sapProfileId)).pipe(tap(_ => { this.profileChanged.next(null) }));
  }

  saveSapProfile(sapProfile: any) {
    return this.http.post<any>(this.url('sapProfile'), sapProfile).pipe(tap(_ => { this.profileChanged.next(null) }));
  }

  @Load()
  downloadSsp(sapProfileId): Observable<any> {
    return this.http
      .get(this.config.api + '/api/sapProfile/download/' + sapProfileId, {responseType: 'arraybuffer', headers: {}});
  }

  uploadAttachment(diagram: File) {
    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    let formData = new FormData();

    formData.append(diagram.name, diagram);

    return this.http
      .post<any>(this.config.api + '/api/sapProfile/uploadAttachment', formData);
  }
}
